// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__kPgmQ","modalMessage":"styles_modalMessage__Q5j3p","modalButton":"styles_modalButton__4ohCR"};